var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23.3333V18.6666H0V0ZM10.5 14H12.8333V15.1666H10.5V14ZM16.3333 10.5H14V15.1666H16.3333V10.5ZM17.5 8.16665H19.8333V15.1666H17.5V8.16665ZM21 2.33335H2.3333V4.66665H21V2.33335ZM10.5 11.0834C10.5 13.3385 8.6718 15.1666 6.41665 15.1666C4.1615 15.1666 2.3333 13.3385 2.3333 11.0834C2.3333 8.82815 4.1615 7 6.41665 7C8.6718 7 10.5 8.82815 10.5 11.0834ZM7.68939 8.45901C7.29271 8.26655 6.85755 8.16659 6.41665 8.16665V11.0834L9.25285 11.7637C9.40791 11.1171 9.33743 10.437 9.05309 9.836C8.76875 9.23499 8.28761 8.74916 7.68939 8.45901Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDashboard);
export default __webpack_public_path__ + "static/media/my-dashboard.9ea407605b5ca91f6b8a333bac79100f.svg";
export { ForwardRef as ReactComponent };